/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=Video&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Video&lang=js"

import "./index.vue?vue&type=style&index=0&id=0d8b7227&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8b7227"]])

export default __exports__